export default __webpack_public_path__ + "static/media/Resume.ba2f687c.pdf";